import Vue from 'vue'
import wx from 'weixin-js-sdk'
import Router from 'vue-router'
import store from '../store'
import Config from '../config/config'
import axios from '@/http'
import qs from 'qs'
import util from '../util/util'
import { SDKRegister } from '../util/weixin'

import Index from '@/pages/index'
// 商品
import GoodsDetail from '@/pages/goods/detail'
import GoodsExchange from '@/pages/goods/exchange'

// 用户
import User from '@/pages/user/index'
import CreditLog from '@/pages/user/credit/log'
import ExchangeLog from '@/pages/user/exchange/log'
import ExchangeDetail from '@/pages/user/exchange/detail'
import Address from '@/pages/user/address/index'
import AddressEdit from '@/pages/user/address/edit'
import Sign from '@/pages/activity/sign'
import Lottery from '@/pages/activity/lottery'
import LotteryLog from '@/pages/activity/log'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'Index',
      component: Index
    },
    {
      path: '/goods/detail',
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/goods/exchange',
      name: 'GoodsExchange',
      component: GoodsExchange
    },
    {
      path: '/activity/sign',
      name: 'Sign',
      component: Sign,
      meta: {
        title: '每日签到'
      }
    },
    {
      path: '/activity/lottery',
      name: 'Lottery',
      component: Lottery,
      meta: {
        title: '抽奖赢好礼'
      }
    },
    {
      path: '/activity/log',
      name: 'LotteryLog',
      component: LotteryLog,
      meta: {
        title: '中奖记录'
      }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/user/credit/log',
      name: 'CreditLog',
      component: CreditLog,
      meta: {
      }
    },
    {
      path: '/user/exchange/log',
      name: 'ExchangeLog',
      component: ExchangeLog,
      meta: {
        title: '我的兑换记录'
      }
    },
    {
      path: '/user/exchange/detail',
      name: 'ExchangeDetail',
      component: ExchangeDetail
    },
    {
      path: '/user/address',
      name: 'Address',
      component: Address,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/user/address/edit',
      name: 'AddressEdit',
      component: AddressEdit
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 定义全局的钩子
router.beforeEach((to, from, next) => {
  if (to.query.appId && to.query.userCode) {
    if (store.state.xAuth.userCode !== to.query.userCode) {
      var payload = { 'appId': to.query.appId, 'userCode': to.query.userCode }
      store.dispatch('setXAuth', payload).then(() => {
        var params = {
          name: to.query.name,
          code: to.query.userCode,
          gender: 0,
          province: to.query.province,
          city: to.query.city,
          avatar: to.query.avatar,
          phone: to.query.phone
        }
        axios.post('/user/', qs.stringify(params)).then(function(res) {
          if (res.data) {
            store.dispatch('setUserInfo', res.data).then(() => {
              next()
            }).catch(() => {
              next()
            })
          }
        }).catch(function(error) {
          console.log(error)
          next()
        })
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  // 设置title
  var title = to.meta.title ? to.meta.title : store.state.userInfo.app.title
  window.document.title = title
  // jssdk未配置或者安卓手机都要再签名
  if (!store.state.jssdkEnabled || util.isAndroid()) {
    // jssdk签名
    const webUrl = Config.baseUrl + to.fullPath
    SDKRegister(webUrl, [], function() {
      store.dispatch('enableJssdk')
      wx.onMenuShareTimeline({
        title: '国花瓷积分商城', // 分享标题
        link: 'https://guohuaci.qumahudong.com/store', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        success: function () {
        // 用户点击了分享后执行的回调函数
        }
      })
      wx.onMenuShareAppMessage({
        title: '国花瓷积分商城', // 分享标题
        desc: '积分兑好礼', // 分享描述
        link: 'https://guohuaci.qumahudong.com/store', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        success: function (res) {
          // 用户点击了分享后执行的回调函数
          console.log('share')
          console.log(res)
        }
      })
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js